const prefix = (name: string) => `router/${name}`;

export const PUSH = prefix('PUSH');
export const REPLACE = prefix('REPLACE');
export const GO = prefix('GO');
export const GO_BACK = prefix('GO_BACK');
export const GO_FORWARD = prefix('GO_FORWARD');
export const LOCATION_CHANGED = prefix('LOCATION_CHANGED');
